import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import styled from 'styled-components';
import { Table, TabsSlide, Description, Link } from '@quikr/ui';
import { apiWrapper } from '@quikr/ui/helpers';
import { common } from '../../../gql/common';

const Label = styled.label`
  flex: 0 0 22%;
  color: ${({ theme }) => theme.colors.TextBeta};
  @media screen and (max-width: 767px) {
    flex: 0 0 50%;
  }
`;

const Li = styled.div`
  padding: 10px 0;
  @media screen and (max-width: 767px) {
    justify-content: space-between;
  }
`;

const Span = styled.span`
  @media screen and (max-width: 767px) {
    text-align: right;
  }
`;

const VapExtrainfo = props => {
  const { loading, error, data } = useQuery(common);
  const [attributeArray, setAttributeArray] = useState(props.data.attr || []);

  const getJobsRSA = async adId => {
    if (!adId) return null;
    await apiWrapper({
      // eslint-disable-next-line no-undef
      url: `${__WP_CLIENT_GQL_ENDPOINT}/o/getJobsRSA`,
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: {
        adId
      }
    }).then(jobsRSA => {
      if (jobsRSA?.length !== 0) setAttributeArray(prev => [...prev, ...jobsRSA]);
    });
  };

  useEffect(() => {
    if (data && !data.isBot && data.category === 'jobs') {
      getJobsRSA(props.data.id);
    }
  }, []);

  if (loading) return null;
  if (error) return null;
  const { isMobile } = data;
  const { description, entityDetails } = props.data;
  const { localities, positionY, top, subroles, websiteurl } = props;
  const tableMaxLength = isMobile ? 5 : 10;
  const tabsData = [];

  tabsData.push({
    id: 'Ad_Details',
    component: (
      <>
        {localities && localities.length > 0 && (
          <Li className="dF">
            <Label>Localities</Label>
            <Span className="fwM">{localities.join(', ')}</Span>
          </Li>
        )}
        {subroles && subroles.length > 0 && (
          <Li className="dF">
            <Label>Sub Roles</Label>
            <Span className="fwM">{subroles.join(', ')}</Span>
          </Li>
        )}
        <Table
          data={attributeArray}
          showDivider
          maxLength={tableMaxLength}
          showViewMoreBtn={attributeArray.length > tableMaxLength}
        />
        {websiteurl && (
          <Li className="dF">
            <Label>Company Website</Label>
            <Link external href={websiteurl} className={'bt2 fwB' + isMobile && ' wBA'}>
              {websiteurl}
            </Link>
          </Li>
        )}
      </>
    ),
    title: `${props.type === 'common' ? 'Ad' : 'Job'} Details`,
    type: 'component'
  });

  tabsData.push({
    id: 'Description',
    component: <Description content={description} maxLength={isMobile ? 380 : 700} />,
    title: 'Description',
    type: 'component'
  });
  if (entityDetails && entityDetails.length > 0) {
    tabsData.push({
      id: 'Specifications',
      component: (
        <Table
          data={entityDetails}
          showDivider
          maxLength={tableMaxLength}
          showViewMoreBtn={entityDetails.length > tableMaxLength}
        />
      ),
      title: 'Specifications',
      type: 'component'
    });
  }
  return <TabsSlide data={tabsData} tabsPosition={true} positionY={positionY} top={top} />;
};

VapExtrainfo.propTypes = {
  data: PropTypes.object,
  localities: PropTypes.array,
  websiteurl: PropTypes.string,
  type: PropTypes.oneOf(['common', 'jobs']),
  positionY: PropTypes.number,
  top: PropTypes.number,
  subroles: PropTypes.array
};

TabsSlide.defaultProps = {
  positionY: 160
};

export default React.memo(VapExtrainfo);
